/* eslint-disable @typescript-eslint/no-unused-vars */
import { Dialog, DialogContent, DialogActions, Button, Grid, TextField, Table, TableBody, TableRow, TableCell, Paper, Typography, TableHead, IconButton as MuiIconButton,
  Box, Chip, TableContainer, Alert, Snackbar, Avatar, CircularProgress, LinearProgress, TableFooter, Pagination, alpha, useTheme
} from '@mui/material';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { ProdutosService, IListagemDeProdutos } from '../../../shared/services/api/estoque/produtos/ProdutosService';
import { v4 as uuidv4 } from 'uuid';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import ImageIcon from '@mui/icons-material/Image';
import QrCodeIcon from '@mui/icons-material/QrCode';
import DescriptionIcon from '@mui/icons-material/Description';
import InventoryIcon from '@mui/icons-material/Inventory';
import NumbersIcon from '@mui/icons-material/Numbers';
import TagIcon from '@mui/icons-material/Tag';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import BrandingWatermarkIcon from '@mui/icons-material/BrandingWatermark';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { Environment } from '../../../shared/environment';


interface IitensEntradaDialog {
  iditens: string;
  idprodutos: string;
  idref: string;
  qtds: number;
  qtde: number;
  un: string;
  preco: number;
  ean?: string;
  subtotal: number;
  desconto: number;
  voutros: number;
  total: number;
  filtro: string;
  referencia?: string;
  marca?: string;
  descricao: string;
  anp?: string;
  original?: boolean;
  localizado?: string;
}
interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: (itens: IitensEntradaDialog[]) => void;
  decimais: number;
  itensIniciais?: IitensEntradaDialog[];
}
export const DialogEntrada: React.FC<Props> = ({
  open,
  onClose,
  onConfirm,
  decimais,
  itensIniciais = []
}) => {
  const theme = useTheme();
  const requestIdRef = useRef(0);
  const [produtos, setProdutos] = useState<IListagemDeProdutos[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [filtro, setFiltro] = useState('');
  const [tipoBusca, setTipoBusca] = useState('descricao');
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [isLoading, setIsLoading] = useState(false);
  const [itens, setItens] = useState<IitensEntradaDialog[]>(itensIniciais);
  const [qtdItens, setQtdItens] = useState(0);
  const [totalValor, setTotalValor] = useState(0);
  const [produtoSelecionado, setProdutoSelecionado] = useState<IListagemDeProdutos | null>(null);
  const [qtd, setQtd] = useState(1);
  const qtdInputRef = useRef<HTMLInputElement>(null);
  const [openItensModal, setOpenItensModal] = useState(false);
  const [precoUnitario, setPrecoUnitario] = useState<number>(0);
  const buscaRef = useRef<HTMLInputElement>(null);
  const tabelaRef = useRef<HTMLDivElement>(null);
  const footerRowRef = useRef<HTMLTableRowElement>(null);
  const [openMsg, setOpenMsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [msgType, setMsgType] = useState<'warning' | 'error' | 'info' | 'success'>('warning');
  const precoInputRef = useRef<HTMLInputElement>(null);
  const btnAddRef = useRef<HTMLButtonElement>(null);
  const ultimaAlturaMedidaRef = useRef<number>(0);
  // Guardam a altura REAL medida no DOM (linha de produto e rodapé de paginação), assim que
  // ficam disponíveis, em vez de depender só dos valores estimados abaixo — evita que um
  // ajuste futuro de fonte/ícone/chip desalinhe a conta e volte a estourar o scroll.
  const alturaLinhaMedidaRef = useRef<number | null>(null);
  const alturaFooterMedidaRef = useRef<number | null>(null);

  // Estimativas usadas somente até a primeira medição real estar disponível (linha e rodapé
  // ainda não renderizados na primeira passada). Depois disso, alturaLinhaMedidaRef e
  // alturaFooterMedidaRef (medidos direto no DOM) têm prioridade — não dependemos apenas de um
  // valor fixo que desalinha sempre que um Chip/ícone/fonte muda de tamanho.
  const ALTURA_LINHA_PADRAO = 41;
  const FOOTER_RESERVADO_PADRAO = 56;

  // Recebe a altura já medida (do próprio ResizeObserver ou de uma leitura síncrona no
  // mount) em vez de reler o layout aqui dentro. Ler getBoundingClientRect de dois elementos
  // irmãos (container e painel) numa segunda passada, agendada via requestAnimationFrame após
  // dois listeners redundantes (ResizeObserver + window "resize"), criava uma corrida onde
  // resizes em sequência perdiam a atualização e o limite ficava preso no último valor que
  // conseguiu ser lido — por isso agora medimos a altura do próprio container uma única vez,
  // no mesmo callback que detectou a mudança.
  const calcularLimiteDinamico = (alturaContainer: number) => {
    const container = tabelaRef.current;
    if (!container) {
      return;
    }

    // O rodapé de paginação só existe no DOM quando totalCount > rowsPerPage, então usamos a
    // última altura real medida (alturaFooterMedidaRef) quando disponível; sem isso ainda,
    // caímos na estimativa fixa.
    const FOOTER_RESERVADO = alturaFooterMedidaRef.current ?? FOOTER_RESERVADO_PADRAO;

    // O <thead> é sempre renderizado, mesmo sem produtos carregados, então dá para medi-lo
    // desde a abertura do modal — diferente da linha do corpo, ele não depende de dados terem
    // chegado da API.
    const headerEl = container.querySelector('thead');
    const alturaHeader = headerEl ? Math.round(headerEl.getBoundingClientRect().height) : 34;

    // Idem para a altura de linha: usa a medição real (feita assim que a primeira leva de
    // produtos renderiza) quando disponível, senão a estimativa fixa.
    const alturaLinha = alturaLinhaMedidaRef.current ?? ALTURA_LINHA_PADRAO;

    const alturaAtual = Math.round(alturaContainer);

    // Ignora recálculos disparados por variações de sub-pixel (comuns em monitores com
    // escala fracionária, ex.: 125%/150%), que não mudam a quantidade real de linhas cabíveis
    // mas mudam a altura medida em frações, reacionando o ResizeObserver indefinidamente.
    if (Math.abs(alturaAtual - ultimaAlturaMedidaRef.current) < 2) {
      return;
    }
    ultimaAlturaMedidaRef.current = alturaAtual;

    const MIN_ROWS = 5;
    const MAX_ROWS = 50;
    // Com a altura de linha e de rodapé só estimadas (medição real ainda não disponível),
    // reserva uma linha inteira de folga para não estourar o scroll; uma vez com as duas
    // medições reais, a folga de meia linha já cobre erros de arredondamento.
    const FOLGA_LINHAS = (alturaLinhaMedidaRef.current !== null && alturaFooterMedidaRef.current !== null) ? 0.5 : 1;
    const alturaDisponivel = alturaAtual - alturaHeader - FOOTER_RESERVADO;

    // Se não sobrou altura calculável (ex.: medição durante um layout intermediário), mantém
    // o rowsPerPage atual em vez de forçar o piso mínimo — evita que uma leitura ruim e
    // pontual derrube o limite para 5 quando há espaço de sobra na tela.
    if (alturaDisponivel <= 0) return;

    const novoLimite = Math.min(
      MAX_ROWS,
      Math.max(MIN_ROWS, Math.floor(alturaDisponivel / alturaLinha - FOLGA_LINHAS))
    );

    setRowsPerPage(prev => (prev === novoLimite ? prev : novoLimite));
  };

  // useLayoutEffect (não useEffect) para rodar de forma síncrona antes da pintura e, mais
  // importante, antes do efeito de busca (que depende de rowsPerPage) disparar a requisição
  // inicial — assim a primeira busca ao abrir o modal já sai com o limite correto, sem uma
  // segunda requisição de correção.
  useLayoutEffect(() => {
    if (!open) return;

    ultimaAlturaMedidaRef.current = 0;

    const container = tabelaRef.current;
    if (!container) return;

    calcularLimiteDinamico(container.getBoundingClientRect().height);

    // Único gatilho de recálculo: o ResizeObserver já dispara para qualquer mudança real de
    // tamanho do container (resize da janela, zoom, F11, abrir/fechar DevTools), então um
    // listener redundante de "resize" da window só serve para competir com ele por um mesmo
    // requestAnimationFrame agendado — em resizes em sequência isso podia cancelar/reagendar o
    // frame na hora errada e perder atualizações, deixando o limite preso no último valor lido.
    // Aqui a própria entry do observer já traz a altura atualizada (contentRect), então o
    // cálculo roda direto no callback, sem uma segunda leitura de layout depois.
    const observer = new ResizeObserver(entries => {
      const entry = entries[0];
      if (entry) {
        calcularLimiteDinamico(entry.contentRect.height);
      }
    });
    observer.observe(container);

    return () => {
      observer.disconnect();
    };
  }, [open]);

  useEffect(() => {
    setPage(0);
  }, [rowsPerPage]);

  useEffect(() => {
    const totalQtd = itens.reduce((sum, item) => sum + item.qtde, 0);
    const totalValorCalculado = itens.reduce((sum, item) => sum + item.subtotal, 0);
    setQtdItens(totalQtd);
    setTotalValor(totalValorCalculado);
  }, [itens]);
  const confirmarVenda = () => {
    if (itens.length === 0) {
      setMsgType('warning');
      setMsg('Adicione pelo menos um item!');
      setOpenMsg(true);
      return;
    }

    onConfirm(itens);
    setItens([]);
    setQtdItens(0);
    setTotalValor(0);
    setFiltro('');
    setPage(0);

    onClose(); // 🔥 FECHA DIALOG
  };
  useEffect(() => {
    if (open) {
      setItens(itensIniciais);
    }
  }, [itensIniciais, open]);

  useEffect(() => {
    if (!open) return;

    const requestId = ++requestIdRef.current;
    setIsLoading(true);
    setProdutos([]);
    setTotalCount(0);
    setSelectedIndex(0);
    setProdutoSelecionado(null);

    ProdutosService.getAll(page + 1, filtro, tipoBusca, rowsPerPage).then(res => {
      if (requestId !== requestIdRef.current) return;
      setIsLoading(false);
      if (!(res instanceof Error)) {
        setProdutos(res.data);
        setTotalCount(res.totalCount || 0);
      } else {
        setProdutos([]);
        setTotalCount(0);
        setMsgType('error');
        setMsg(res.message);
        setOpenMsg(true);
      }
    });

  }, [filtro, tipoBusca, open, page, rowsPerPage]);

  // Assim que uma linha de produto real (tem data-row-index; a de "carregando" e a de "vazio"
  // não têm) e/ou o rodapé de paginação são renderizados, mede a altura real deles no DOM e
  // substitui as estimativas usadas em calcularLimiteDinamico. Só força um recálculo quando a
  // medição muda de fato — nas renderizações seguintes ela repete o mesmo valor e não dispara
  // nada, então isso corrige a conta no máximo uma vez por abertura, sem loop de requisições.
  useLayoutEffect(() => {
    if (!open) return;
    const container = tabelaRef.current;
    if (!container) return;

    let mudou = false;

    const linhaEl = container.querySelector('tbody tr[data-row-index]');
    if (linhaEl) {
      const alturaLinha = Math.round(linhaEl.getBoundingClientRect().height);
      if (alturaLinha > 0 && alturaLinhaMedidaRef.current !== alturaLinha) {
        alturaLinhaMedidaRef.current = alturaLinha;
        mudou = true;
      }
    }

    const footerEl = footerRowRef.current;
    if (footerEl) {
      const alturaFooter = Math.round(footerEl.getBoundingClientRect().height);
      if (alturaFooter > 0 && alturaFooterMedidaRef.current !== alturaFooter) {
        alturaFooterMedidaRef.current = alturaFooter;
        mudou = true;
      }
    }

    if (mudou) {
      // Força a recalcular mesmo que a altura do container não tenha mudado: o espaço
      // disponível é o mesmo, mas agora com uma altura de linha/rodapé mais precisa.
      ultimaAlturaMedidaRef.current = -1;
      calcularLimiteDinamico(container.getBoundingClientRect().height);
    }
  }, [produtos, totalCount, rowsPerPage, open]);

  useEffect(() => {
    if (open) {
      setTimeout(() => buscaRef.current?.focus(), 100);
    }
  }, [open]);

  useEffect(() => {
    if (tabelaRef.current && selectedIndex >= 0) {
      const selectedRow = tabelaRef.current.querySelector(`[data-row-index="${selectedIndex}"]`);
      if (selectedRow) {
        selectedRow.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  }, [selectedIndex]);
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'F8') {
        event.preventDefault();
        const tipos = ['descricao', 'referencia', 'codinterno'];
        const currentIndex = tipos.indexOf(tipoBusca);
        const nextIndex = (currentIndex + 1) % tipos.length;
        setTipoBusca(tipos[nextIndex]);
        setFiltro('');
        setSelectedIndex(0);
        setPage(0);
        setTimeout(() => buscaRef.current?.focus(), 100);
      }

      if (event.key === 'F9') {
        event.preventDefault();
        confirmarVenda();
      }
    };

    if (open) {
      window.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [open, tipoBusca, itens]);

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (produtos.length > 0) {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        setSelectedIndex(prev => {
          const newIndex = Math.min(prev + 1, produtos.length - 1);
          return newIndex;
        });
      }

      if (event.key === 'ArrowUp') {
        event.preventDefault();
        setSelectedIndex(prev => {
          const newIndex = Math.max(prev - 1, 0);
          return newIndex;
        });
      }

      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        const prod = produtos[selectedIndex];
        if (prod) {
          selecionarProduto(prod, selectedIndex);
        }
      }
    }

    if (event.key === 'Escape') {
      onClose();
    }
  };
  const selecionarProduto = (prod: IListagemDeProdutos, index: number) => {
    setSelectedIndex(index);
    setProdutoSelecionado(prod);
    setQtd(1);
    setPrecoUnitario(prod.preco);
    setSelectedIndex(-1);

    buscaRef.current?.blur();

    setTimeout(() => {
      if (qtdInputRef.current) {
        qtdInputRef.current.focus();
        qtdInputRef.current.select();
      }
    }, 100);
  };

  useEffect(() => {
    if (produtoSelecionado) {
      setQtd(1);
      setPrecoUnitario(produtoSelecionado.preco);
    }
  }, [produtoSelecionado]);



  const adicionarItem = () => {
    if (!produtoSelecionado) return;
    if (precoUnitario < produtoSelecionado.preco) {
      setMsgType('warning');
      setMsg('Preço menor que o preço de venda!');
      setOpenMsg(true);

      setTimeout(() => {
        precoInputRef.current?.focus();
        precoInputRef.current?.select();
      }, 100);
      return;
    }
    const preco = precoUnitario;
    const novaQtd = qtd;

    let adicionou = false;

    setItens(old => {
      const itemExistenteIndex = old.findIndex(
        item => item.idprodutos === produtoSelecionado.idproduto
      );

      if (itemExistenteIndex !== -1) {
        const itemExistente = old[itemExistenteIndex];
        const quantidadeSomada = itemExistente.qtde + novaQtd;

        const novoTotalSomado = Number(
          (quantidadeSomada * preco).toFixed(decimais)
        );
        const itensAtualizados = [...old];
        itensAtualizados[itemExistenteIndex] = {
          ...itemExistente,
          qtde: quantidadeSomada,
          subtotal: novoTotalSomado,
          preco: preco
        };

        adicionou = true; // ✅ MARCA QUE DEU CERTO
        return itensAtualizados;
      }
      // 🔥 NOVO ITEM
      const novoTotal = Number((novaQtd * preco).toFixed(decimais));
      const novo: IitensEntradaDialog = {
        iditens: uuidv4(),
        idprodutos: produtoSelecionado.idproduto,
        idref: produtoSelecionado.idref,
        qtds: 0,
        qtde: novaQtd,
        un: produtoSelecionado.un,
        preco: preco,
        subtotal: novoTotal,
        desconto: 0,
        voutros: 0,
        total: 0,
        filtro: 'descricao',
        descricao: produtoSelecionado.descricao,
        ean: produtoSelecionado.ean,
        referencia: produtoSelecionado.referencia,
        marca: produtoSelecionado.marca,
        original: produtoSelecionado.original,
        localizado: produtoSelecionado.localizado
      };
      adicionou = true; // ✅ MARCA QUE DEU CERTO
      return [...old, novo];
    });

    // 🔥 SÓ MOSTRA SUCESSO SE REALMENTE ADICIONOU
    if (!adicionou) return;

    setMsgType('success');
    setMsg('Item adicionado com sucesso!');
    setOpenMsg(true);

    setProdutoSelecionado(null);
    setPrecoUnitario(0);
    setQtd(1);
    setSelectedIndex(-1);

    setTimeout(() => {
      buscaRef.current?.focus();
    }, 100);
  };

  const removerItem = (iditens: string) => {
    setItens(old => old.filter(item => item.iditens !== iditens));
  };

  const atualizarQuantidade = (iditens: string, novaQtd: number) => {
    if (novaQtd <= 0) {
      removerItem(iditens);
      return;
    }

    setItens(old => old.map(item => {
      if (item.iditens === iditens) {
        const novoTotal = Number((novaQtd * item.preco).toFixed(decimais));
        return {
          ...item,
          qtde: novaQtd,
          subtotal: novoTotal
        };
      }
      return item;
    }));
  };

  const ItensModal = () => (
    <Dialog
      open={openItensModal}
      onClose={() => setOpenItensModal(false)}
      maxWidth="lg"
      fullWidth
    >
      <Box sx={{
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        p: 2,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <Typography variant="h6" fontWeight="bold">
          Itens Selecionados
        </Typography>
        <IconButton onClick={() => setOpenItensModal(false)} sx={{ color: 'white' }}>
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent>
        {itens.length > 0 ? (
          <>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow sx={{
                    backgroundColor: theme.palette.mode === 'dark'
                      ? alpha(theme.palette.primary.dark, 0.3)
                      : alpha(theme.palette.primary.main, 0.06),
                    '& th': {
                      fontWeight: 'bold',
                      color: theme.palette.mode === 'dark'
                        ? theme.palette.primary.light
                        : theme.palette.primary.dark,
                      fontSize: '0.7rem',
                      py: 1,
                    }
                  }}>
                    <TableCell sx={{ fontSize: '0.7rem' }}>Produto</TableCell>
                    <TableCell align="center" sx={{ fontSize: '0.7rem' }}>Quantidade</TableCell>
                    <TableCell align="center" sx={{ fontSize: '0.7rem' }}>UN</TableCell>
                    <TableCell align="right" sx={{ fontSize: '0.7rem' }}>Preço</TableCell>
                    <TableCell align="right" sx={{ fontSize: '0.7rem' }}>Total</TableCell>
                    <TableCell align="center" sx={{ fontSize: '0.7rem' }}>Ações</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {itens.map((item) => (
                    <TableRow key={item.iditens} hover>
                      <TableCell sx={{ fontSize: '0.68rem', py: 0.5 }}>
                        <Box display="flex" alignItems="center" gap={1}>
                          <Avatar
                            sx={{
                              width: 28,
                              height: 28,
                              bgcolor: theme.palette.grey[200]
                            }}
                            src={process.env.REACT_APP_URL_IMGPRODUTOS}
                          >
                            {!item.anp && <ImageIcon sx={{ fontSize: 14 }} />}
                          </Avatar>
                          <Typography variant="body2" sx={{ fontSize: '0.68rem' }}>{item.descricao}</Typography>
                        </Box>
                      </TableCell>
                      <TableCell align="center" sx={{ fontSize: '0.68rem', py: 0.5 }}>
                        <TextField
                          size="small"
                          sx={{ width: 90 }}
                          value={item.qtde.toLocaleString('pt-BR', {
                            minimumFractionDigits: decimais,
                            maximumFractionDigits: decimais
                          })}
                          onChange={(e) => {
                            const digitsOnly = e.target.value.replace(/\D/g, '');
                            const divisor = decimais === 4 ? 10000 : 100;
                            const numberValue = Number(digitsOnly) / divisor;
                            if (!isNaN(numberValue)) {
                              atualizarQuantidade(item.iditens, numberValue);
                            }
                          }}
                          inputProps={{ style: { fontSize: '0.68rem', padding: '6px' } }}
                        />
                      </TableCell>
                      <TableCell align="center" sx={{ fontSize: '0.68rem', py: 0.5 }}>{item.un}</TableCell>
                      <TableCell align="right" sx={{ fontSize: '0.68rem', py: 0.5 }}>
                        {(item.preco ?? 0).toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL'
                        })}
                      </TableCell>
                      <TableCell align="right" sx={{ fontSize: '0.68rem', py: 0.5 }}>
                        {(item.total?? 0).toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL'
                        })}
                      </TableCell>
                      <TableCell align="center" sx={{ py: 0.5 }}>
                        <IconButton
                          size="small"
                          onClick={() => removerItem(item.iditens)}
                          sx={{ color: theme.palette.error.main }}
                        >
                          <DeleteIcon fontSize="small" sx={{ fontSize: '18px' }} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={{ mt: 2, p: 2, backgroundColor: theme.palette.grey[50], borderRadius: 1 }}>
              <Grid container justifyContent="flex-end">
                <Grid item>
                  <Typography variant="h6">
                    Total Geral: {(totalValor ?? 0).toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL'
                    })}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </>
        ) : (
          <Typography variant="body1" align="center" sx={{ py: 4, color: 'text.secondary' }}>
            Nenhum item selecionado
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenItensModal(false)} variant="outlined">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        maxWidth="xl"
        onKeyDown={handleKeyDown}
        PaperProps={{
          sx: {
            borderRadius: 2,
            overflow: 'hidden',
            width: '95%',
            maxWidth: '1400px',
            height: '90vh',
            // Não usar um teto fixo em px aqui (ex.: 800px): como height já é 90vh, um maxHeight
            // menor que isso travava o Dialog nesse valor fixo em qualquer tela com mais de
            // ~890px de altura útil — a maioria dos monitores —, fazendo calcularLimiteDinamico
            // sempre calcular o mesmo número de linhas independente do tamanho real da tela.
            maxHeight: '95vh',
            minHeight: '420px'
          }
        }}
      >
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={openMsg}
          autoHideDuration={msgType === 'error' ? null : 6000}
          onClose={() => setOpenMsg(false)}
        >
          <Alert onClose={() => setOpenMsg(false)} severity={msgType} variant='filled'>
            {msg}
          </Alert>
        </Snackbar>

        <DialogContent sx={{ p: 2, height: 'calc(100% - 60px)', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, height: '100%', minHeight: 0 }}>
            {/* BARRA DE BUSCA COM TOTAIS */}
            <Box sx={{ flexShrink: 0 }}>
              <Paper sx={{
                p: 1.5,
                backgroundColor: theme.palette.mode === 'dark'
                  ? alpha(theme.palette.background.paper, 0.6)
                  : theme.palette.grey[50]
              }}>
                <Grid container spacing={1.5} alignItems="center">
                  <Grid item xs={12} sm={3}>
                    <TextField
                      select
                      fullWidth
                      size="small"
                      label="Tipo de Busca"
                      value={tipoBusca}
                      onChange={(e) => {
                        setTipoBusca(e.target.value);
                        setFiltro('');
                        setSelectedIndex(0);
                        setPage(0);
                      }}
                      SelectProps={{ native: true }}
                      sx={{
                        backgroundColor: theme.palette.mode === 'dark'
                          ? alpha(theme.palette.background.default, 0.8)
                          : 'white',
                        '& .MuiInputLabel-root': {
                          color: theme.palette.mode === 'dark'
                            ? theme.palette.grey[400]
                            : theme.palette.text.primary
                        },
                        '& .MuiInputBase-root': {
                          color: theme.palette.mode === 'dark'
                            ? theme.palette.common.white
                            : theme.palette.text.primary
                        }
                      }}
                      inputProps={{ style: { fontSize: '0.75rem' } }}
                      InputLabelProps={{ style: { fontSize: '0.7rem' } }}
                    >
                      <option value="descricao">Descrição</option>
                      <option value="referencia">Referência</option>
                      <option value="codinterno">Código Interno</option>



                    </TextField> <Typography
                      variant="caption"
                      sx={{
                        fontSize: '0.6rem',
                        color: 'text.secondary',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5,
                        mt: 0.5,
                        ml: 0.5
                      }}
                    >
                      <strong style={{
                        backgroundColor: theme.palette.mode === 'dark' ? '#444' : '#e0e0e0',
                        padding: '0px 4px',
                        borderRadius: '3px',
                        fontFamily: 'monospace',
                        fontSize: '0.55rem'
                      }}>F8</strong> alternar tipo de busca
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={5}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Digite para buscar produto"
                      value={filtro}
                      inputRef={buscaRef}
                      onChange={(e) => {
                        setFiltro(e.target.value);
                        setSelectedIndex(0);
                        setPage(0);
                      }}
                      InputProps={{
                        startAdornment: <SearchIcon sx={{ mr: 1, color: 'action.active', fontSize: '18px' }} />
                      }}
                      sx={{
                        backgroundColor: theme.palette.mode === 'dark'
                          ? alpha(theme.palette.background.default, 0.8)
                          : 'white',
                        '& .MuiInputLabel-root': {
                          color: theme.palette.mode === 'dark'
                            ? theme.palette.grey[400]
                            : theme.palette.text.primary
                        },
                        '& .MuiInputBase-root': {
                          color: theme.palette.mode === 'dark'
                            ? theme.palette.common.white
                            : theme.palette.text.primary
                        }
                      }}
                      inputProps={{ style: { fontSize: '0.75rem' } }}
                      InputLabelProps={{ style: { fontSize: '0.7rem' } }}
                    />
                    <Typography
                      variant="caption"
                      sx={{
                        fontSize: '0.6rem',
                        color: 'text.secondary',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5,
                        mt: 0.5,
                        ml: 0.5
                      }}
                    >
                      <span style={{
                        backgroundColor: theme.palette.mode === 'dark' ? '#444' : '#e0e0e0',
                        padding: '0px 4px',
                        borderRadius: '3px',
                        fontFamily: 'monospace',
                        fontSize: '0.55rem',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '2px'
                      }}>
                        ↑ ↓
                      </span> navegar pelos produtos
                      <span style={{ marginLeft: '8px' }}>
                        <span style={{
                          backgroundColor: theme.palette.mode === 'dark' ? '#444' : '#e0e0e0',
                          padding: '0px 4px',
                          borderRadius: '3px',
                          fontFamily: 'monospace',
                          fontSize: '0.55rem'
                        }}>
                          Enter
                        </span> selecionar
                      </span>
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <Box sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-end',
                      gap: 1.5
                    }}>
                      <Chip
                        label={`Itens: ${qtdItens}`}
                        variant="outlined"
                        sx={{
                          fontWeight: 'bold',
                          fontSize: '0.7rem',
                          height: '28px',
                          color: theme.palette.mode === 'dark' ? theme.palette.common.white : 'inherit',
                          borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[600] : 'inherit'
                        }}
                      />
                      <Chip
                        label={`Total: ${(totalValor?? 0).toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL'
                        })}`}
                        color="primary"
                        sx={{ fontWeight: 'bold', fontSize: '0.7rem', height: '28px', backgroundColor: theme.palette.primary.main, color: 'white' }}
                      />
                      <MuiIconButton
                        size="small"
                        onClick={() => setOpenItensModal(true)}
                        sx={{
                          backgroundColor: theme.palette.primary.main,
                          color: 'white',
                          width: '28px',
                          height: '28px',
                          '&:hover': {
                            backgroundColor: theme.palette.primary.dark
                          }
                        }}
                      >
                        <VisibilityIcon sx={{ fontSize: '16px' }} />
                      </MuiIconButton>
                    </Box>
                  </Grid>
                </Grid>
              </Paper>
            </Box>

            {/* TABELA DE PRODUTOS - COM FONTE MENOR E DESTAQUE DO ITEM EM FOCO */}
            <Box sx={{ flex: 1, minHeight: 0, display: 'flex' }}>
              <Paper
                elevation={0}
                sx={{
                  borderRadius: 1,
                  overflow: 'hidden',
                  border: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
                  backgroundColor: theme.palette.mode === 'dark'
                    ? alpha(theme.palette.background.paper, 0.4)
                    : 'transparent',
                  display: 'flex',
                  flexDirection: 'column',
                  flex: 1,
                  minHeight: 0
                }}
              >
                <TableContainer
                  sx={{
                    flex: 1,
                    minHeight: 0,
                    overflow: 'auto',
                    // Reserva o espaço da barra de rolagem vertical mesmo quando ela não é
                    // necessária. Sem isso, cada vez que o número de linhas muda, a barra
                    // vertical aparece/some, a largura útil muda, o que pode empurrar a
                    // tabela para dentro/fora do overflow horizontal — a barra horizontal
                    // então aparece/some também, alterando a altura útil e retroalimentando
                    // o cálculo de linhas por página em um loop.
                    scrollbarGutter: 'stable',
                  }}
                  ref={tabelaRef}
                >
                  <Table size="small" stickyHeader sx={{ minWidth: '100%' }}>
                    <TableHead>
                      <TableRow sx={{
                        backgroundColor: theme.palette.mode === 'dark'
                          ? alpha(theme.palette.primary.dark, 0.3)
                          : alpha(theme.palette.primary.main, 0.06),
                        '& th': {
                          fontWeight: 'bold',
                          color: theme.palette.mode === 'dark'
                            ? theme.palette.primary.light
                            : theme.palette.primary.dark,
                          fontSize: '0.68rem',
                          py: 0.8,
                          px: 0.6,
                          borderBottom: `1px solid ${theme.palette.mode === 'dark'
                            ? alpha(theme.palette.primary.light, 0.15)
                            : alpha(theme.palette.primary.main, 0.15)}`
                        }
                      }}>
                        <TableCell sx={{ width: '50px', fontSize: '0.68rem' }}>
                          <Box display="flex" alignItems="center" gap={0.3}>
                            <ImageIcon fontSize="small" sx={{ fontSize: '14px' }} />
                            <span>Imagem</span>
                          </Box>
                        </TableCell>
                        <TableCell sx={{ width: '110px', fontSize: '0.68rem' }}>
                          <Box display="flex" alignItems="center" gap={0.3}>
                            <QrCodeIcon fontSize="small" sx={{ fontSize: '14px' }} />
                            <span>Código EAN</span>
                          </Box>
                        </TableCell>
                        <TableCell sx={{ fontSize: '0.68rem' }}>
                          <Box display="flex" alignItems="center" gap={0.3}>
                            <DescriptionIcon fontSize="small" sx={{ fontSize: '14px' }} />
                            <span>Descrição</span>
                          </Box>
                        </TableCell>
                        <TableCell sx={{ width: '80px', fontSize: '0.68rem' }}>
                          <Box display="flex" alignItems="center" gap={0.3}>
                            <InventoryIcon fontSize="small" sx={{ fontSize: '14px' }} />
                            <span>UN</span>
                          </Box>
                        </TableCell>
                        <TableCell sx={{ width: '80px', fontSize: '0.68rem' }}>
                          <Box display="flex" alignItems="center" gap={0.3}>
                            <NumbersIcon fontSize="small" sx={{ fontSize: '14px' }} />
                            <span>QTD</span>
                          </Box>
                        </TableCell>
                        <TableCell sx={{ width: '90px', fontSize: '0.68rem' }}>
                          <Box display="flex" alignItems="center" gap={0.3}>
                            <BrandingWatermarkIcon fontSize="small" sx={{ fontSize: '14px' }} />
                            <span>Marca</span>
                          </Box>
                        </TableCell>
                        <TableCell sx={{ width: '90px', fontSize: '0.68rem' }}>
                          <Box display="flex" alignItems="center" gap={0.3}>
                            <TagIcon fontSize="small" sx={{ fontSize: '14px' }} />
                            <span>Referência</span>
                          </Box>
                        </TableCell>
                        <TableCell sx={{ width: '90px', fontSize: '0.68rem' }}>
                          <Box display="flex" alignItems="center" gap={0.3}>
                            <TagIcon fontSize="small" sx={{ fontSize: '14px' }} />
                            <span>Tipo</span>
                          </Box>
                        </TableCell>
                        <TableCell sx={{ width: '80px', fontSize: '0.68rem' }}>
                          <Box display="flex" alignItems="center" gap={0.3}>
                            <LocationOnIcon fontSize="small" sx={{ fontSize: '14px' }} />
                            <span>Local</span>
                          </Box>
                        </TableCell>

                        <TableCell align='right' sx={{ width: '100px', fontSize: '0.68rem' }}>
                          <Box display="flex" alignItems="center" gap={0.3} justifyContent="flex-end">
                            <AttachMoneyIcon fontSize="small" sx={{ fontSize: '14px' }} />
                            <span>Preço Compra</span>
                          </Box>
                        </TableCell>
                        <TableCell align='right' sx={{ width: '100px', fontSize: '0.68rem' }}>
                          <Box display="flex" alignItems="center" gap={0.3} justifyContent="flex-end">
                            <AttachMoneyIcon fontSize="small" sx={{ fontSize: '14px' }} />
                            <span>Preço Venda</span>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {produtos.map((prod, index) => {
                        const isFocused = index === selectedIndex;
                        const isSelected = produtoSelecionado?.idproduto === prod.idproduto;

                        return (
                          <TableRow
                            key={prod.idproduto}
                            data-row-index={index}
                            onClick={() => selecionarProduto(prod, index)}
                            hover
                            selected={isFocused}  // ✅ usa a prop nativa do MUI
                            sx={{
                              cursor: 'pointer',
                              transition: 'all 0.15s ease',
                              backgroundColor: isSelected
                                ? alpha(theme.palette.success.main, 0.15)
                                : 'transparent',

                              '&:hover': {
                                backgroundColor: theme.palette.mode === 'dark'
                                  ? alpha(theme.palette.grey[700], 0.3)
                                  : alpha(theme.palette.grey[300], 0.4),
                              },

                              '& td': {
                                py: 0.5,
                                px: 0.6,
                                fontSize: '0.68rem',
                                fontWeight: isSelected ? 500 : 400,
                              },
                            }}
                          >
                            <TableCell sx={{ py: 0.5 }}>
                              <Avatar
                                sx={{
                                  width: 32,
                                  height: 32,
                                  margin: 'auto',
                                  bgcolor: theme.palette.grey[200],
                                  fontSize: '16px',
                                }}
                                alt={prod.descricao}
                                src={process.env.REACT_APP_URL_IMGPRODUTOS + prod.anp}
                              >
                                {!prod.anp && <ImageIcon sx={{ fontSize: '14px' }} />}
                              </Avatar>
                            </TableCell>

                            <TableCell sx={{ py: 0.5 }}>
                              <Typography
                                variant="body2"
                                fontFamily="monospace"
                                color="text.secondary"
                                sx={{
                                  fontSize: '0.68rem',
                                }}
                              >
                                {prod.ean || 'Não informado'}
                              </Typography>
                            </TableCell>

                            <TableCell sx={{ py: 0.5 }}>
                              <Typography
                                variant="body2"
                                color="text.primary"
                                sx={{
                                  fontSize: '0.68rem'
                                }}
                              >
                                {prod.descricao}
                              </Typography>
                            </TableCell>

                            <TableCell sx={{ py: 0.5 }}>
                              <Typography variant="body2" color="text.primary" sx={{ fontSize: '0.68rem' }}>
                                {prod.un}
                              </Typography>
                            </TableCell>

                            <TableCell align='left' sx={{ py: 0.5 }}>
                              <Box textAlign="left">
                                <Typography
                                  variant="body2"
                                  fontWeight="bold"
                                  color="success.main"
                                  sx={{ fontSize: '0.7rem', letterSpacing: '0.2px' }}
                                >
                                  {(prod.quan ?? 0).toLocaleString('pt-BR')}
                                </Typography>
                                <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.6rem' }}>
                                  Estoque
                                </Typography>
                              </Box>
                            </TableCell>
                            <TableCell sx={{ py: 0.5 }}>
                              <Chip
                                label={prod.marca || 'Sem Marca'}
                                size="small"
                                color="primary"
                                variant={theme.palette.mode === 'dark' ? 'filled' : 'outlined'}
                                sx={{
                                  fontWeight: 'medium',
                                  height: '18px',
                                  fontSize: '0.6rem',
                                  '& .MuiChip-label': { px: 0.6, fontSize: '0.6rem' },
                                }}
                              />
                            </TableCell>

                            <TableCell sx={{ py: 0.5 }}>
                              <Typography variant="body2" color="text.primary" sx={{ fontSize: '0.68rem' }}>
                                {prod.referencia}
                              </Typography>
                            </TableCell>

                            <TableCell sx={{ py: 0.5 }}>
                              <Chip
                                label={prod.original ? 'Original' : 'Similar'}
                                size="small"
                                color={prod.original ? 'success' : 'warning'}
                                variant={theme.palette.mode === 'dark' ? 'filled' : 'outlined'}
                                sx={{
                                  fontWeight: 'bold',
                                  height: '18px',
                                  fontSize: '0.6rem',
                                  '& .MuiChip-label': { px: 0.6, fontSize: '0.6rem' }
                                }}
                              />
                            </TableCell>

                            <TableCell sx={{ py: 0.5 }}>
                              <Typography variant="body2" color="text.primary" sx={{ fontSize: '0.68rem' }}>
                                {prod.localizado}
                              </Typography>
                            </TableCell>

                            <TableCell align='right' sx={{ py: 0.5 }}>
                              <Box textAlign="right">
                                <Typography
                                  variant="body2"
                                  fontWeight="bold"
                                  color="success.main"
                                  sx={{
                                    fontSize: '0.7rem',
                                    letterSpacing: '0.2px'
                                  }}
                                >
                                  {(prod.preco ?? 0).toLocaleString('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL'
                                  })}
                                </Typography>
                                <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.6rem' }}>
                                  Preço de Compra
                                </Typography>
                              </Box>
                            </TableCell>
                            <TableCell align='right' sx={{ py: 0.5 }}>
                              <Box textAlign="right">
                                <Typography
                                  variant="body2"
                                  fontWeight="bold"
                                  color="success.main"
                                  sx={{
                                    fontSize: '0.7rem',
                                    letterSpacing: '0.2px'
                                  }}
                                >
                                  {(prod.pvenda ?? 0).toLocaleString('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL'
                                  })}
                                </Typography>
                                <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.6rem' }}>
                                  Preço de venda
                                </Typography>
                              </Box>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>

                    {produtos.length === 0 && isLoading && (
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={10} align="center" sx={{ py: 4 }}>
                            <Box display="flex" flexDirection="column" alignItems="center" gap={1.5}>
                              <CircularProgress size={26} thickness={4} />
                              <Typography variant='body2' color='text.secondary' sx={{ fontSize: '0.7rem' }}>
                                Carregando produtos...
                              </Typography>
                            </Box>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )}

                    {produtos.length === 0 && !isLoading && (
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={10} align="center" sx={{ py: 3 }}>
                            <Box>
                              <ImageIcon sx={{
                                fontSize: 32,
                                color: theme.palette.mode === 'dark'
                                  ? alpha(theme.palette.text.secondary, 0.4)
                                  : 'text.secondary',
                                mb: 1
                              }} />
                              <Typography variant='h6' color='text.secondary' gutterBottom sx={{ fontSize: '0.8rem' }}>
                                {Environment.LISTAGEM_VAZIA}
                              </Typography>
                              <Typography variant='body2' color='text.secondary' sx={{ fontSize: '0.68rem' }}>
                                {filtro ? 'Tente ajustar os filtros de busca' : 'Nenhum produto encontrado'}
                              </Typography>
                            </Box>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )}

                    <TableFooter>
                      {isLoading && (
                        <TableRow>
                          <TableCell colSpan={10} sx={{ p: 0 }}>
                            <LinearProgress sx={{ height: '1.5px' }} />
                          </TableCell>
                        </TableRow>
                      )}
                      {totalCount > rowsPerPage && (
                        <TableRow ref={footerRowRef}>
                          <TableCell colSpan={10} sx={{ py: 1 }}>
                            <Box display="flex" justifyContent="center">
                              <Pagination
                                page={page + 1}
                                count={Math.ceil(totalCount / rowsPerPage)}
                                onChange={(_, newPage) => setPage(newPage - 1)}
                                color="primary"
                                size="small"
                                shape="rounded"
                                showFirstButton
                                showLastButton
                                siblingCount={1}
                                boundaryCount={1}
                                sx={{
                                  '& .MuiPaginationItem-root': {
                                    color: theme.palette.mode === 'dark' ? theme.palette.common.white : 'inherit'
                                  }
                                }}
                              />
                            </Box>
                            <Box textAlign="center" mt={0.5}>
                              <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.6rem' }}>
                                Total de {totalCount} produto{totalCount !== 1 ? 's' : ''}
                              </Typography>
                            </Box>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableFooter>
                  </Table>
                </TableContainer>
              </Paper>
            </Box>

            {/* PAINEL DE ADIÇÃO */}
            <Box sx={{ flexShrink: 0 }}>
              <Paper sx={{
                p: 1.5,
                backgroundColor: theme.palette.mode === 'dark'
                  ? alpha(theme.palette.primary.main, 0.12)
                  : alpha(theme.palette.primary.main, 0.04),
                border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`
              }}>
                <Grid container spacing={1.5} alignItems="center">
                  <Grid item xs={12} sm={2}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Quantidade"
                      inputRef={qtdInputRef}
                      value={qtd.toLocaleString('pt-BR', {
                        minimumFractionDigits: decimais,
                        maximumFractionDigits: decimais
                      })}
                      onChange={(e) => {
                        const digitsOnly = e.target.value.replace(/\D/g, '');
                        const divisor = decimais === 4 ? 10000 : 100;
                        const numberValue = Number(digitsOnly) / divisor;
                        setQtd(numberValue);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' && produtoSelecionado) {
                          e.preventDefault();
                          precoInputRef.current?.focus();
                          precoInputRef.current?.select();
                        }
                      }}
                      inputProps={{ style: { fontSize: '0.7rem' } }}
                      InputLabelProps={{ style: { fontSize: '0.65rem' } }}
                      sx={{
                        '& .MuiInputLabel-root': {
                          color: theme.palette.mode === 'dark' ? theme.palette.grey[400] : 'inherit'
                        },
                        '& .MuiInputBase-root': {
                          color: theme.palette.mode === 'dark' ? theme.palette.common.white : 'inherit',
                          backgroundColor: theme.palette.mode === 'dark'
                            ? alpha(theme.palette.background.paper, 0.6)
                            : 'white'
                        }
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      label="Produto Selecionado"
                      size="small"
                      value={produtoSelecionado?.descricao || 'Nenhum produto selecionado'}
                      fullWidth
                      disabled
                      sx={{
                        '& .MuiInputBase-root': {
                          backgroundColor: produtoSelecionado ? alpha(theme.palette.success.main, 0.08) : 'transparent',
                          fontWeight: produtoSelecionado ? 'bold' : 'normal',
                          fontSize: '0.7rem',
                          color: theme.palette.mode === 'dark' ? theme.palette.common.white : 'inherit'
                        },
                        '& .MuiInputLabel-root': {
                          color: theme.palette.mode === 'dark' ? theme.palette.grey[400] : 'inherit'
                        }
                      }}
                      InputLabelProps={{ style: { fontSize: '0.65rem' } }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={2.5}>
                    <TextField
                      fullWidth
                      size="small"
                      inputRef={precoInputRef}
                      label="Preço Unitário"
                      value={precoUnitario.toLocaleString('pt-BR', {
                        minimumFractionDigits: decimais,
                        maximumFractionDigits: decimais
                      })}
                      onChange={(e) => {
                        const digitsOnly = e.target.value.replace(/\D/g, '');
                        const divisor = decimais === 4 ? 10000 : 100;
                        const numberValue = Number(digitsOnly) / divisor;
                        setPrecoUnitario(numberValue);
                      }}
                      inputProps={{ style: { fontSize: '0.7rem' } }}
                      InputLabelProps={{ style: { fontSize: '0.65rem' } }}
                      sx={{
                        '& .MuiInputLabel-root': {
                          color: theme.palette.mode === 'dark' ? theme.palette.grey[400] : 'inherit'
                        },
                        '& .MuiInputBase-root': {
                          color: theme.palette.mode === 'dark' ? theme.palette.common.white : 'inherit',
                          backgroundColor: theme.palette.mode === 'dark'
                            ? alpha(theme.palette.background.paper, 0.6)
                            : 'white'
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          adicionarItem();
                        }
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={2}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Total do Item"
                      value={(qtd * precoUnitario).toLocaleString('pt-BR', {
                        minimumFractionDigits: decimais,
                        maximumFractionDigits: decimais
                      })}
                      disabled
                      sx={{
                        '& .MuiInputBase-root': {
                          backgroundColor: alpha(theme.palette.info.main, 0.08),
                          fontWeight: 'bold',
                          fontSize: '0.7rem',
                          color: theme.palette.mode === 'dark' ? theme.palette.common.white : 'inherit'
                        },
                        '& .MuiInputLabel-root': {
                          color: theme.palette.mode === 'dark' ? theme.palette.grey[400] : 'inherit'
                        }
                      }}
                      InputLabelProps={{ style: { fontSize: '0.65rem' } }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={1.5}>
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      onClick={adicionarItem}

                      disabled={!produtoSelecionado || qtd <= 0}
                      startIcon={<AddIcon />}
                      sx={{
                        height: '48px',
                        fontSize: '0.8rem',
                        fontWeight: 'bold',
                        textTransform: 'none',
                        boxShadow: 2,
                        '&:hover': {
                          boxShadow: 4,
                          transition: 'all 0.2s'
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          adicionarItem();
                        }
                      }}

                    >
                      Adicionar
                    </Button>
                  </Grid>
                </Grid>
              </Paper>
            </Box>
          </Box>
        </DialogContent>

        <DialogActions sx={{ p: 1.5, borderTop: `1px solid ${theme.palette.divider}` }}>
          <Button onClick={onClose} variant="outlined" color="inherit" size="small">
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={confirmarVenda}
            sx={{ fontWeight: 'bold' }}
            size="small"
          >
            Confirmar Itens (F9)
          </Button>
        </DialogActions>
      </Dialog>

      <ItensModal />
    </>
  );
};